@if (survey()) {
  <h2 class="text-2xl font-bold mb-5 text-grey-0">Omdöme i Nationella Patientenkäten</h2>

  <div class="content">
    <p class="mb-4">Här kan du se omdömen som {{ name() }} har fått i Nationella Patientenkäten.</p>

    <a (click)="openInfoModal()" class="mb-8 flex gap-2 font-bold">Om Nationella Patientenkäten
      <app-ui-icon color="green" name="arrow_right"></app-ui-icon>
    </a>

    <div class="surveys">
      @for (row of rows(); let j = $index; track j) {
        <div [class]="'perrow-' + perRow()" class="survey-general">
          @for (dimension of row; let i = $index; track dimension.name) {
            <app-cpru-survey-dimension
              (openPanel)="togglePanelState(j * perRow() + i, true)"
              [dimension]="dimension"
              [id]="'survey-dimension-' + (j * perRow() + i)"
              [opened]="panelsState()[j * perRow() + i]"
            ></app-cpru-survey-dimension>
          }
        </div>
        <div class="survey-details">
          @for (dimension of row; let i = $index; track dimension.name) {
            <app-cpru-survey-questions
              (closePanel)="togglePanelState(j * perRow() + i, false)"
              [class]="'chevron-' + perRow() + '-' + i"
              [dimension]="dimension"
              [name]="name()"
              [opened]="panelsState()[j * perRow() + i]"
            ></app-cpru-survey-questions>
          }
        </div>
      }
    </div>
  </div>
}
